import React from 'react';

const PaginationComponent = ({ pageIndex, pageSize, totalItems, setPageIndex, setPageSize }) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  
  const handlePrev = () => {
    if (pageIndex > 0) setPageIndex(pageIndex - 1);
  };
  
  const handleNext = () => {
    if (pageIndex < totalPages - 1) setPageIndex(pageIndex + 1);
  };
  
  const handlePageClick = (page) => {
    setPageIndex(page);
  };
  
  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setPageIndex(0);
  };
  
  // Generar rango de páginas visibles
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(0, pageIndex - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible);
    
    if (end - start < maxVisible) {
      start = Math.max(0, end - maxVisible);
    }
    
    for (let i = start; i < end; i++) {
      pages.push(i);
    }
    return pages;
  };
  
  if (totalPages <= 1 && totalItems <= pageSize) return null;
  
  return (
    <div className="d-flex align-items-center justify-content-between mt-3 pt-3 border-top">
      <div className="d-flex align-items-center gap-2">
        <span className="text-muted" style={{ fontSize: '13px' }}>
          Mostrando {pageIndex * pageSize + 1}-{Math.min((pageIndex + 1) * pageSize, totalItems)} de {totalItems}
        </span>
        <select
          className="form-select form-select-sm"
          value={pageSize}
          onChange={handlePageSizeChange}
          style={{ width: 'auto' }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      
      <ul className="pagination pagination-separated pagination-sm mb-0">
        <li className={`page-item ${pageIndex === 0 ? 'disabled' : ''}`}>
          <button className="page-link" onClick={handlePrev} disabled={pageIndex === 0}>
            <i className="ri-arrow-left-s-line"></i>
          </button>
        </li>
        
        {getPageNumbers().map((page) => (
          <li key={page} className={`page-item ${pageIndex === page ? 'active' : ''}`}>
            <button className="page-link" onClick={() => handlePageClick(page)}>
              {page + 1}
            </button>
          </li>
        ))}
        
        <li className={`page-item ${pageIndex >= totalPages - 1 ? 'disabled' : ''}`}>
          <button className="page-link" onClick={handleNext} disabled={pageIndex >= totalPages - 1}>
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PaginationComponent;
